if (!customElements.get('gift-with-purchase')) {
  customElements.define('gift-with-purchase', class GiftWithPurchase extends HTMLElement {
    constructor() {
      super();
      this.configuration = JSON.parse(this.querySelector('template[data-configuration]').content.textContent);
      console.log(`gift-with-purchase`, this.configuration)
      this.gift = this.configuration.gift;
      this.eligibleCustomer = true;
      if (!this.gift) return;
      this.init();
    }

    init() {
      window.addItem = window.addItem || {};
      window.removeItem = window.removeItem || {};
       
      if (this.configuration.eligibleCustomers.length) {
        const customer = this.configuration.eligibleCustomers
          .some(customer => customer.includes(this.configuration.currentCustomer));
        if (!customer) this.eligibleCustomer = false;
      }

      const inCart = this.configuration.cart.items.find(item =>
        item.variant_id === this.gift.id && item.properties['_free_gift'] === this.configuration.id
      );
      const isEligible = this.checkEligibility() && this.eligibleCustomer && this.gift.available;
      
      if (isEligible && inCart) {
        window.removeItem[this.configuration.id] = false;
      } else if (isEligible && !inCart) {
        if (window.addItem[this.configuration.id] && !window.removeItem[this.configuration.id]) return;
        
        window.removeItem[this.configuration.id] = false; 
        if (this.gift.available) {
          this.add(this.gift.id);
          return;
        }

      } else if (!isEligible && !inCart) {

      } else if (!isEligible && inCart) {
        this.remove(inCart.key);
      }
    }

    checkEligibility() {
      const { minPurchase } = this.configuration;

      const meetsThreshold = Number(minPurchase) && this.configuration.cart.total_price >= parseInt(minPurchase, 10);
      return meetsThreshold;
    }    

    remove(itemKey) {
      const minicart = document.querySelector('mini-cart') || document.querySelector('main-cart');
      if (!minicart) return;
      window.removeItem[this.configuration.id] = true;
      minicart.classList.add('loading');
      minicart.updateQty(itemKey, 0)
        .then((res) => {
          if (!res) return;
          minicart.updateCartHtml(res).then(() => {
            minicart.querySelector('form').scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
          });
        }).finally(() => minicart.classList.remove('loading'));
    }

    add(idToAdd) {
      const minicart = document.querySelector('mini-cart') || document.querySelector('main-cart');
      window.addItem[this.configuration.id] = true;
      if (!minicart) return;
      minicart.classList.add('loading');
      minicart.addToCart({
        data: {
          id: idToAdd,
          quantity: 1,
          properties: {
            _free_gift: this.configuration.id
          },
          sections: minicart.sectionId,
          sections_url: window.location.pathname
        }
      }).then(() => minicart.classList.remove('loading'));
    }
  });
}